import Blockly from 'blockly/browser'
import Util, { defineBlock, defineStmtBlock } from '../Util'

defineBlock(
  'javascript_arbitrary_statement',
  {
    message0: 'stmt: %1',
    args0: [
      {
        type: 'field_input',
        name: 'statement',
        text: ';'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Any code statement goes here',
    colour: '#aaaaaa'
  },
  function(block) {
    let code = block.getFieldValue('statement')
    return code + '\n'
  }
)

defineBlock(
  'javascript_arbitrary_expression',
  {
    message0: 'expr: %1',
    args0: [
      {
        type: 'field_input',
        name: 'expression',
        text: '0'
      }
    ],
    output: null,
    tooltip: 'Any code expression goes here',
    colour: '#aaaaaa'
  },
  function(block) {
    let expression = block.getFieldValue('expression')
    return [`${expression}`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'javascript_expression_statement',
  {
    message0: 'do %1',
    args0: [
      {
        type: 'input_value',
        name: 'ignoredInput'
      }
    ],
    tooltip: 'Allows output producing expressions to be used as statements',
    colour: '#aaaaaa'
  },
  function(block) {
    let ignoredInput =
      Blockly.JavaScript.valueToCode(block, 'ignoredInput', Blockly.JavaScript.ORDER_ATOMIC) || ''
    return `${ignoredInput};\n`
  }
)

defineBlock(
  'javascript_untyped_add',
  {
    message0: '%1 + %2',
    args0: [
      {
        type: 'input_value',
        name: 'A'
      },
      {
        type: 'input_value',
        name: 'B'
      }
    ],
    output: null,
    tooltip: 'Adds two operands together (text or numbers)',
    colour: Util.colors.misc,
    inputsInline: true
  },
  function(block) {
    const a = Blockly.JavaScript.valueToCode(block, 'A', Blockly.JavaScript.ORDER_ATOMIC) || `''`
    const b = Blockly.JavaScript.valueToCode(block, 'B', Blockly.JavaScript.ORDER_ATOMIC) || `''`
    const code = `${a} + ${b}`
    return [code, Blockly.JavaScript.ORDER_ADDITION]
  }
)

defineBlock(
  'javascript_literal_null',
  {
    message0: 'null',
    output: null,
    tooltip: `The special null value`,
    colour: Util.colors.misc
  },
  function() {
    return ['null', Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'javascript_literal_regexp',
  {
    message0: '/%1/%2',
    args0: [
      {
        type: 'field_input',
        name: 'PATTERN',
        text: ''
      },
      {
        type: 'field_input',
        name: 'FLAGS',
        text: ''
      }
    ],
    output: null,
    tooltip: `A regular expression`,
    colour: Util.colors.misc
  },
  function(block) {
    let pattern = block.getFieldValue('PATTERN') || '.*'
    let flags = block.getFieldValue('FLAGS') || ''
    const code = `/${pattern}/${flags}`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'javascript_unary_expression',
  {
    message0: '%1 %2',
    args0: [
      {
        type: 'field_dropdown',
        name: 'OP',
        options: [
          ['+', '+'],
          ['-', '-'],
          ['negated bits of', '~'],
          ['not', '!'],
          ['delete property', 'delete'],
          ['type of', 'typeof']
        ]
      },
      {
        type: 'input_value',
        name: 'VALUE'
      }
    ],
    output: null,
    tooltip: 'An unary operator',
    colour: Util.colors.misc
  },
  function(block) {
    let op = block.getFieldValue('OP')
    if (op && op.length > 1) {
      op += ' '
    }
    const value =
      Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_ATOMIC) || `0`
    const code = `${op}${value}`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'javascript_throw',
  {
    message0: 'throw error %1',
    args0: [
      {
        type: 'input_value',
        name: 'MESSAGE'
      }
    ],
    previousStatement: null,
    tooltip: 'Throws an error. Catch it with a try/catch block or let the flow fail',
    colour: Blockly.Msg.LOGIC_HUE
  },
  function(block) {
    let message =
      Blockly.JavaScript.valueToCode(block, 'MESSAGE', Blockly.JavaScript.ORDER_NONE) || `''`
    return `throw new Error(${message});\n`
  }
)

defineBlock(
  'javascript_newline',
  {
    message0: 'line break',
    tooltip: 'Line break character',
    output: 'String',
    colour: Blockly.Msg.TEXTS_HUE
  },
  function(block) {
    return [`'\\n'`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'javascript_logic_operation',
  {
    message0: '%1 %2 %3',
    args0: [
      {
        type: 'input_value',
        name: 'A'
      },
      {
        type: 'field_dropdown',
        name: 'OP',
        options: [['and', 'AND'], ['or', 'OR']]
      },
      {
        type: 'input_value',
        name: 'B'
      }
    ],
    inputsInline: true,
    output: null,
    tooltip: `Combine values using logical 'and' and 'or' operations`,
    colour: Blockly.Msg.LOGIC_HUE
  },
  function(block) {
    let a = Blockly.JavaScript.valueToCode(block, 'A', Blockly.JavaScript.ORDER_NONE) || `''`
    let b = Blockly.JavaScript.valueToCode(block, 'B', Blockly.JavaScript.ORDER_NONE) || `''`
    let operator = block.getFieldValue('OP') === 'AND' ? '&&' : '||'
    return [`${a} ${operator} ${b}`, Blockly.JavaScript.ORDER_LOGICAL_AND]
  }
)
